import { Component, Input, OnInit } from '@angular/core';
import { AuthServiceZ } from '../../authentification/auth-service.service';

declare var $;

@Component({
  selector: 'app-jobs-badge-status',
  templateUrl: './jobs-badge-status.component.html',
  styleUrls: ['./jobs-badge-status.component.scss'],
})
export class JobsBadgeStatusComponent implements OnInit {
  @Input() item;
  @Input() status;
  @Input() jrh;
  @Input() failureReason;
  @Input() reportedTo;
  @Input() status4Partner = null;
  @Input() showDateUnderBadge = null;
  @Input() withBorder: boolean = true;

  // 1 new
  // 2 assigned
  // 3 accepted by driver
  // 4 declined by driver
  // 5 start the job
  // 6 finish the job
  // 7 decline after accepting
  // 8 decline by the admin
  // 9 unsuccessful ( retour au magasin ) scanned by amen xD
  // 10 pickedUp
  // 11 no pickup address
  // 12 no dropoff address
  // 13 no pickup and dropoff addresses
  // 14 declined by client
  // 15 driver failed to deliver
  // 16 retour definitif
  // 17 retour au client
  // 24 retour vers dépôt
  // 30 exchange delivered
  // 31 exchange entered depot
  // 32 exchange in transfer
  // 33 exchange returned to business
  user;

  constructor(private authService: AuthServiceZ) {}

  ngOnInit(): void {
    this.authService.credentials.user
      ? (this.user = this.authService.credentials.user.userType)
      : (this.user = '');
  }

  openPointRelaisInfo() {
    $('#pointRelaisMap').modal('show');
  }
}
